import { lazy } from 'react'

export const routeBackOffice = [
  {
    exact: true,
    path: '/bo/frm_user',
    component: lazy(() => import('../views/back-office/menu/user/table/Index')),
  },
  {
    exact: true,
    path: '/bo/frm_user/new',
    component: lazy(() => import('../views/back-office/menu/user/fiche/index')),
  },
  {
    exact: true,
    path: '/bo/frm_user/edit/:id',
    component: lazy(() => import('../views/back-office/menu/user/fiche/index')),
  },
  {
    exact: true,
    path: '/bo/frm_profil',
    component: lazy(() =>
      import('../views/back-office/menu/profil/table/Index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_profil/new',
    component: lazy(() =>
      import('../views/back-office/menu/profil/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_profil/edit/:id',
    component: lazy(() =>
      import('../views/back-office/menu/profil/fiche/index')
    ),
  },
  // Group utilisateur
  {
    exact: true,
    path: '/bo/frm_GroupUser',
    component: lazy(() =>
      import('../views/back-office/menu/gestion_group/table/index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_GroupUser/new',
    component: lazy(() =>
      import('../views/back-office/menu/gestion_group/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_GroupUser/edit/:id',
    component: lazy(() =>
      import('../views/back-office/menu/gestion_group/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_GroupUser/admin/:name/:id',
    component: lazy(() =>
      import('../views/back-office/menu/gestion_group/administer/navigation')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_GroupUser/initialiser/:name/:id',
    component: lazy(() =>
      import('../views/back-office/menu/gestion_group/initialiser/index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_InitialisationGroupe',
    component: lazy(() =>
      import('../views/back-office/menu/adminGenerale/index')
    ),
  },

  {
    exact: true,
    path: '/bo/frm_Pays',
    component: lazy(() => import('../views/back-office/menu/pays/table/Index')),
  },
  {
    exact: true,
    path: '/bo/frm_Pays/edit/:id',
    component: lazy(() => import('../views/back-office/menu/pays/fiche/index')),
  },
  {
    exact: true,
    path: '/bo/frm_Pays/new',
    component: lazy(() => import('../views/back-office/menu/pays/fiche/index')),
  },

  {
    path: '/bo/dashboard',
    routes: [
      {
        exact: true,
        path: '/bo/dashboard',
        component: lazy(() =>
          import('../views/back-office/menu/accueil/index')
        ),
      },
    ],
  },
  {
    exact: true,
    path: '/bo/frm_Audit',
    component: lazy(() =>
      import('../views/back-office/menu/audit/table/index')
    ),
  },
  // currency bo
  {
    exact: true,
    path: '/bo/currency',
    component: lazy(() =>
      import('../views/back-office/menu/currency/table/Index')
    ),
  },
  {
    exact: true,
    path: '/bo/currency/new',
    component: lazy(() =>
      import('../views/back-office/menu/currency/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/bo/currency/edit/:id',
    component: lazy(() =>
      import('../views/back-office/menu/currency/fiche/index')
    ),
  },
  // Code opération
  {
    exact: true,
    path: '/bo/frm_CodeOperation',
    component: lazy(() =>
      import('../views/back-office/menu/codeOperation/table/Index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_CodeOperation/new',
    component: lazy(() =>
      import('../views/back-office/menu/codeOperation/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_CodeOperation/edit/:id',
    component: lazy(() =>
      import('../views/back-office/menu/codeOperation/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_ReleveCompte',
    component: lazy(() =>
      import('../views/back-office/menu/account-releve/index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_ReleveCompte/detail/:id',
    component: lazy(() =>
      import('../views/back-office/menu/account-releve/detail/index')
    ),
  },
  {
    exact: true,
    path: '/bo/frm_Job',
    component: lazy(() => import('../views/back-office/menu/job/index')),
  },
]

